import { createFileRoute, notFound } from '@tanstack/react-router'

import { LoadingIndicator } from '@/core/components/LoadingIndicator'
import {
  FEATURE_CORE_SKILLS_ASSESSMENT,
  FEATURE_GROWTH_MAP,
} from '@/core/constants/features'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'

export const Route = createFileRoute('/_learning/growth-map')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-growth-map',
        }),
      },
    ],
  }),
  beforeLoad: ({ context: { user } }) => {
    const hasFeature =
      user?.features.includes(FEATURE_CORE_SKILLS_ASSESSMENT) ||
      user?.features.includes(FEATURE_GROWTH_MAP)

    if (!hasFeature) {
      throw notFound()
    }
  },
  pendingComponent: () => <LoadingIndicator />,
})
